import React, { useContext, useEffect, useRef, useState } from "react";
import { View, Text, TouchableOpacity } from "react-native";
import { Avatar } from "react-native-elements";
import { useNavigation } from "@react-navigation/native";

import { ButtonAddRoute, TextAddRoute, TextTitlePage } from "./styles";
import {
  Header,
  Container,
  Content,
  TextField,
  Button,
  CustomDropDown,
  ContentButton,
  BottomSheet,
} from "../../../../components";
import RegisterDriverContext from "../../../../context/registerDriver";
import RouteContext from "../../../../context/route";
import UserContext from "../../../../context/user";
import { Modalize } from "react-native-modalize";

function SelectDriverAdmin() {
  const navigation = useNavigation();
  const bottomSheetErrorRef = useRef<Modalize>(null);
  const { driversSelects } = useContext(RegisterDriverContext);
  const { setNewRoute } = useContext(RouteContext);
  const { user } = useContext(UserContext);
  const [driverOpen, setDriverOpen] = useState(false);
  const [driverValue, setDriverValue] = useState(0);
  const [dateDelivery, setDateDelivery] = useState('');

  async function handleSubmit() {
    const dateSplit = dateDelivery.split('/');
    const newDate = new Date(parseInt(dateSplit[2]), parseInt(dateSplit[1])-1, parseInt(dateSplit[0]));
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if(!isNaN(newDate.getTime()) && newDate >= today){
      setNewRoute({ driver: driverValue, isAdmin: true, date: newDate, routes: [] });
      setDateDelivery('');
      navigation.navigate("ListRoutesAdmin", '');
    }else {
      bottomSheetErrorRef.current?.open();
    }
  }

  return (
    <Container>
      <Header type="simple" title="Motorista" />
      <Content>
        <TextTitlePage>Selecione um motorista</TextTitlePage>
        <CustomDropDown
          open={driverOpen}
          value={driverValue}
          items={driversSelects}
          setOpen={setDriverOpen}
          setValue={setDriverValue}
          placeholder="Motorista"
          setItems={setDriverValue}
        />
        <TextField
          label='Data de entrega'
          placeholder='Digite a data de entrega'
          value={dateDelivery}
          mask="date"
          onChangeText={(text: string) => setDateDelivery(text)}
        />
      </Content>
      <ContentButton>
        <Button
          title="Continuar"
          onPress={handleSubmit}
          disabled={driverValue > 0 ? false : true}
        />
      </ContentButton>
      <BottomSheet
          bottomSheetRef={bottomSheetErrorRef}
          title="Data inválida"
          description="Por favor verifique se a data não é inferior a data atual e tente novamente"
          textButton="Entendi"
          typeButton="filled"
          accessibilityHintButton="Entendi"
          onClose={() => bottomSheetErrorRef.current?.close()}
          onPress={() => bottomSheetErrorRef.current?.close()}
        />
    </Container>
  );
}

export default SelectDriverAdmin;
